import { render, staticRenderFns } from "./KnowledgeQA.vue?vue&type=template&id=0e151146&scoped=true"
import script from "./KnowledgeQA.vue?vue&type=script&lang=js"
export * from "./KnowledgeQA.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeQA.vue?vue&type=style&index=0&id=0e151146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e151146",
  null
  
)

export default component.exports